












import { DateType } from 'expangine-runtime';
import { DateTextBoxOptions } from './DateTextBoxTypes';
import TypeInputBase from '../TypeInputBase';


export default TypeInputBase<DateType, DateTextBoxOptions, Date>(Date).extend({
  name: 'DateTextBox',
  computed: {
    inputType(): string {
      return this.type.options.withTime ? 'datetime' : 'date';
    },
    hasHint(): boolean {
      return !this.hideHint;
    },
    hideHint(): boolean {
      return !this.settings.options.hint;
    },
  },
});
